// extracted by mini-css-extract-plugin
export default {"cls1":"mentions_milestone_ping-cls1_dFi","cls2":"mentions_milestone_ping-cls2__7_ mentions_milestone_ping-cls1_dFi"};